class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/session/fetch'
			},
			create_sessionMessage: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/session/message'
			},
			update_sessionMessage: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/session/message/id'
			},
			getClientBalance: {
				headers: {
					'xt-user-token':
						'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRUb2tlbklkIjoiMTFmZTdjMjUtNjNiYi00MWIxLTljZjMtNTc1YjY2YTUzYTZkIiwiY2xpZW50VXVpZCI6IjkxNjJkNjIwLTQ1NWUtNDAwNi04ZTM5LWNhNmZhZTEyYzA0MCIsImNsaWVudCI6IjEiLCJhY3RvciI6IjEiLCJ1c2VyVG9rZW5JZCI6ImRkZWJiYmI1LTU1NzAtNDg0NC05MWZmLWZhMGJkYTllMDY1YyIsInRpbWUiOjE2OTcwNjQzMDQwNDcsIm1heF90b2tlbl9jb3VudCI6LTEsImlhdCI6MTY5NzA2NDMwNH0.jlsxDeid1eMhoBL1nylpQ3i3pL0AVd3fU3LWYKOP-RU'
				},
				method: 'post',
				path: '/get/client/balance'
			}
		};
	}
}

export default new APIS();
